import { PropostaVersao } from 'models/PropostaVersao';
import {
  Button,
  Card,
  Col,
  FormGroup,
  Input,
  Label,
  Row,
  Table,
} from 'reactstrap';
import MostrarValor from 'views/components/MostrarValor';
import InputSelect from 'components/InputSelect';
import { iAcessoPrograma, iComboList, iPropostaDados } from '../..';

export default function PrazoMedio({
  propostaVersao,
  isModoSimulacao,
  onChange,
  acessoPrograma,
  listaDifal,
}: {
  propostaVersao: iPropostaDados;
  isModoSimulacao: boolean;
  onChange: (a: iPropostaDados) => void;
  acessoPrograma: iAcessoPrograma;
  listaDifal: iComboList[];
}): JSX.Element {
  // console.log({
  //   a: propostaVersao.dataCriacao,
  // });

  function formatEAdicaoDias(dateString: string, days: number): string {
    const date = new Date(dateString);
    date.setDate(date.getDate() + days);

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
  }

  return (
    <Card className="shadow p-3">
      <Row className="mt-2 mb-2">
        <Col sm="3">
          <Label className="form-control-label mt-3">Data Embarque:</Label>
          <Input
            type="date"
            value={
              propostaVersao?.valores?.dataEmbarque
                ? new Date(propostaVersao.valores.dataEmbarque)
                    .toISOString()
                    .split('T')[0]
                : formatEAdicaoDias(String(propostaVersao.dataCriacao), 90)
            }
            disabled={!isModoSimulacao}
            onChange={event => {
              onChange({
                ...propostaVersao,
                valores: {
                  ...propostaVersao.valores,
                  dataEmbarque: event.target.value
                    ? new Date(`${event.target.value}T10:10:10`)
                    : null,
                },
              });
            }}
          />
        </Col>
        <Col sm="3">
          <Label className="form-control-label mt-3">
            Custo Financeiro (%):
          </Label>
          <Input
            type="number"
            disabled={
              !isModoSimulacao ||
              !acessoPrograma.custoFinanceiro.temAcesso ||
              !propostaVersao.outros?.isRegramentoGeral
            }
            value={propostaVersao.variaveisComerciais.custoFinanceiro ?? 0}
            onChange={text => {
              onChange({
                ...propostaVersao,
                variaveisComerciais: {
                  ...propostaVersao.variaveisComerciais,
                  custoFinanceiro: Number(text.target.value) ?? 0,
                },
              });
            }}
          />
        </Col>
        <Col sm="4">
          <Label className="form-control-label mt-3">DIFAL por conta</Label>
          <InputSelect
            options={listaDifal}
            value={
              propostaVersao.variaveisComerciais.difalPorConta ?? 'do Cliente'
            }
            disabled={!isModoSimulacao || acessoPrograma.difal.acessoLimitado}
            hideNoOption
            onChange={text => {
              onChange({
                ...propostaVersao,
                variaveisComerciais: {
                  ...propostaVersao.variaveisComerciais,
                  difalPorConta: text.target.value ?? 'do Cliente',
                },
              });
            }}
          />
        </Col>
      </Row>
    </Card>
  );
}
